import LogsCard from '@pages/Manage/components/LogsCard.tsx';

export const LogsWidget = () => <LogsCard headDivider />;

export default LogsWidget;
